import { css } from 'emotion';

import { colors } from '../styles';

export const checkmarkIcon = css`
  color: ${colors.success.default};
  margin-top: 1px;
`;

export const errorIcon = css`
  color: ${colors.error.default};
  margin-top: 1px;
`;

export const addressesList = css`
  width: 100%;
  padding-left: 0;
  list-style: none;
`;

export const addressesListItem = css`
  min-height: 20px;
  padding: 10px 25px;
  &:nth-child(even) {
    background-color: ${colors.custom.lightestGray50};
  }
  /* Overriding default style */
  list-style: none;
`;

export const expansionPanel = css`
  && {
    margin: 0;
  }
`;
